import { render } from "./Crest.vue?vue&type=template&id=0aa4e13f"
import script from "./Crest.vue?vue&type=script&lang=js"
export * from "./Crest.vue?vue&type=script&lang=js"
script.render = render

export default script